<!--
 * @Author: natsu
 * @Date: 2020-09-02 16:51:59
 * @LastEditors: natsu
 * @LastEditTime: 2021-09-09 16:13:09
 * @Description: file content
-->
<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/vue.png" /></div>
      <p>Vue-Patches</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/vue-patches/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "2.6.10",
          linkList: [
            ur + "2.6.10/vue.js",
            ur + "2.6.10/vue.min.js"
          ]
        },
        {
          label: "2.5.17",
          linkList: [
            ur + "2.5.17/vue.js",
            ur + "2.5.17/vue.min.js"
          ]
        },

        {
          label: "2.5.2",
          linkList: [
            ur + "2.5.2/vue.js",
            ur + "2.5.2/vue.min.js"
          ]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListVuePatches.vue